import noddiAsync from './NoddiAsync';
import { InputData, NoddiAsyncReturnType, URLKeysTypes } from './resources/resources';

export function invalidateQueryExactMatch<UrlKey extends URLKeysTypes>({
  urlKey,
  input
}: {
  urlKey: UrlKey;
  input: InputData<UrlKey>;
}) {
  const queryKey = (input !== undefined ? [urlKey, input] : [urlKey]) as [UrlKey, ...unknown[]];

  return noddiAsync.queryClient.invalidateQueries({ queryKey });
}

export function invalidateQuery({ urlKey }: { urlKey: URLKeysTypes }) {
  return noddiAsync.queryClient.invalidateQueries({ queryKey: [urlKey] });
}

export function setQueryDataExactMatch<UrlKey extends URLKeysTypes>({
  urlKey,
  input,
  data
}: {
  urlKey: UrlKey;
  input: InputData<UrlKey>;
  data: NoddiAsyncReturnType<UrlKey, InputData<UrlKey>>;
}) {
  const queryKey = (input !== undefined ? [urlKey, input] : [urlKey]) as [UrlKey, ...unknown[]];
  noddiAsync.queryClient.setQueryData(queryKey, data);
}
